/**
 * Relay v1.2.0
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

module.exports = require('./lib/ReactRelayPublic.js');


//////////////////
// WEBPACK FOOTER
// ./~/react-relay/index.js
// module id = 615
// module chunks = 3